import { useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Offcanvas from "react-bootstrap/Offcanvas";
import { NavbarMentor } from "../components/sharedComponents/NavbarMentor";
import { SideBar } from "../components/structure/SideBar";

export const LayoutMentor = ({ collapse = false, setCollapse, children }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const smScreen = useMediaQuery("(max-width:1023px)");

    const locale = localStorage.getItem("locale") || "en";
    const isRTL = locale === "ar";

    useEffect(() => {
        setCollapse(false);
    }, [setCollapse]);

    return (
        <Container fluid className="mentor-design">
            <Row className="mentor-design__row-holder flex-nowrap">
                {/* Sidebar — desktop only */}
                {!smScreen && (
                    <Col
                        className={`mentor-design__row-holder--sidebar ${collapse ? "col-md-1" : "col-md-2"}`}
                    >
                        <SideBar
                            collapse={collapse}
                            setCollapse={setCollapse}
                        />
                    </Col>
                )}

                {/* Mobile offcanvas sidebar — always mounted, shown via `show` */}
                <Offcanvas
                    show={smScreen && show}
                    onHide={handleClose}
                    placement={isRTL ? "end" : "start"}
                    className="mobile-sidebar-offcanvas"
                >
                    <Offcanvas.Header closeButton />
                    <Offcanvas.Body>
                        <SideBar
                            collapse={false}
                            setCollapse={() => {}}
                            onNavItemClick={handleClose}
                        />
                    </Offcanvas.Body>
                </Offcanvas>

                {/* Main content */}
                <Col
                    className={`p-0 mentor-design__row-holder--content ${!smScreen && collapse ? "col-md-11" : !smScreen ? "col-md-10" : "col-12"}`}
                >
                    <div className="mentor-design__row-holder--content__navbar p-0">
                        <NavbarMentor
                            onMenuClick={smScreen ? handleShow : undefined}
                            showMenuBtn={smScreen}
                        />
                    </div>
                    <div className="mentor-design__row-holder--content__pages">
                        {children}
                    </div>
                </Col>
            </Row>
        </Container>
    );
};
